/* eslint-disable react/prop-types */
import { url } from "inspector";
import React, { useEffect, useState } from "react";

import Siga from "../../Images/siga.png";
import Siga1 from "../../Images/1.png";
import Siga2 from "../../Images/2.png";
import Siga3 from "../../Images/3.png";
import Siga4 from "../../Images/4.png";
import Siga5 from "../../Images/5.png";
import IconFollow1 from "../../Images/IconFollow1.png";
import IconFollow2 from "../../Images/IconFollow2.png";
import IconFollow3 from "../../Images/IconFollow3.png";
import IconFollow4 from "../../Images/IconFollow4.png";
import IconSpot from "../../Images/IconSpot.png";
import IconDeezer from "../../Images/IconDeezer.png";


import * as S from "./estilos";

function Follow(props: any) {
  const MandaInsta = () => {
    window.open("https://www.instagram.com/cantordaniel/", "_blank");
  };

  const MandaYoutube = () => {
    window.open("https://www.youtube.com/user/DanielOficial", "_blank");
  };

  const MandaTwitter = () => {
    window.open("https://twitter.com/cantordaniel", "_blank");
  };

  const MandaFace = () => {
    window.open("https://www.facebook.com/cantorDaniel", "_blank");
  };

  const MandaSpot = () => {
    window.open("https://open.spotify.com/artist/2wwWukJBsCikjlj7vlbQkM?si=oypBmx0ITYWpzsHKYHFLyw&nd=1", "_blank");
  };

  const MandaDeezer = () => {
    window.open("https://www.deezer.com/br/artist/64998", "_blank");
  };

  return (
    <>
      <S.Bg>
      <S.OutFollow>
        <S.TextFollow1> <img src={Siga}/></S.TextFollow1>
        <S.Container>
          <S.ContainerLeft><img src={Siga1}/></S.ContainerLeft>
          <S.ContainerRight><img src={Siga2}/></S.ContainerRight>
        </S.Container>
              <S.Container>
          <S.ContainerCenter><img src={Siga3}/></S.ContainerCenter>
          <S.ContainerCenter><img src={Siga4}/></S.ContainerCenter> 
          <S.ContainerCenter><img src={Siga5}/></S.ContainerCenter>
        </S.Container>
      </S.OutFollow>
      </S.Bg>
      {/* <S.OutImgFollow>
        <img src={BgFollow} />
      </S.OutImgFollow> */}
    </>
  );
}

export default Follow;
